var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.333 49.1468H34.6663L22.7996 57.04C21.0396 58.2134 18.6663 56.9602 18.6663 54.8268V49.1468C10.6663 49.1468 5.33301 43.8135 5.33301 35.8135V19.8133C5.33301 11.8133 10.6663 6.47998 18.6663 6.47998H45.333C53.333 6.47998 58.6663 11.8133 58.6663 19.8133V35.8135C58.6663 43.8135 53.333 49.1468 45.333 49.1468Z",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.9998 30.2932V29.7333C31.9998 27.92 33.1199 26.9599 34.2399 26.1866C35.3332 25.4399 36.4264 24.48 36.4264 22.72C36.4264 20.2666 34.4532 18.2932 31.9998 18.2932C29.5465 18.2932 27.5732 20.2666 27.5732 22.72",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.9883 36.6666H32.0123",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupport);
export default __webpack_public_path__ + "static/media/OnlineSupport.995bf2885b73b1988f09a00e77cc26bb.svg";
export { ForwardRef as ReactComponent };